<template>
    <header class="home-header">
        <div class="home-header__inner">
            <!-- Logo -->
            <div class="home-header__logo">
                <img :src="logo" alt="Logo" class="icon" />
            </div>

            <!-- Navigation -->
            <div class="home-header__nav">
                <a
                    v-for="item in bodySection"
                    :key="item.id"
                    class="nav-link"
                    href="javascript:void(0);"
                    @click="$emit('open-modal', item)"
                >
                    {{ item.headings }}
                </a>

                <HeroDropdown :loggedIn="loggedIn" />

                <a
                    :href="urlGenerator(loggedIn ? 'admin/dashboard' : 'admin/users/login')"
                    class="btn btn-primary"
                >
                    {{ $t(loggedIn ? 'dashboard' : 'login') }}
                </a>
            </div>
        </div>
    </header>
</template>

<script>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import HeroDropdown from "../CareerPage/HeroDropdown.vue";

export default {
    name: "HomeHeader",
    components: {
        HeroDropdown
    },
    props: {
        logo: {
            type: String,
            required: true
        },
        loggedIn: {
            type: Boolean,
            default: false
        },
        bodySection: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            urlGenerator
        };
    }
};
</script>

<style scoped lang="scss">
.home-header {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1000;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.home-header__inner {
    max-width: 1400px;
    margin: 0 auto;
    padding: 1.25rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}

.home-header__logo {
    flex-shrink: 0;
}

.icon {
    width: 100%;
    max-width: 480px;
    min-width: 200px;
    height: auto;
}

.home-header__nav {
    display: flex;
    align-items: center;
    gap: 1rem;
    white-space: nowrap;
}

.nav-link {
    padding: 0.75rem 0.25rem;
    text-decoration: none;
    cursor: pointer;
}

/* ---------- BREAKPOINTS ---------- */

@media (max-width: 992px) {
    .home-header__nav {
        width: 100%;
        justify-content: flex-end;
        margin-top: 0.75rem;
    }

    .icon {
        max-width: 280px;
    }
}

@media (max-width: 768px) {
    .icon {
        max-width: 240px;
    }
}

@media (max-width: 650px) {
    .home-header__inner {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 1rem;
    }

    .home-header__nav {
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;
    }

    .icon {
        max-width: 200px;
    }
}

</style>
